import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCTA } from './SectionCTA';
import { roadmapSteps } from '../data/content';
export function RoadmapSteps() {
  return <section className="w-full bg-brand-950 px-5 py-16 md:py-24" data-id="element-289" data-mp="3n6w2cqqua1q1">
      <div className="mx-auto max-w-5xl" data-id="element-290" data-mp="3n4jg41e1t576">
        <SectionHeading dark eyebrow="The Sensory Modulation Treatment Roadmap™" title="From Assessment Findings to a Structured Intervention Plan" subtitle="Follow a practical six-stage educational planning process." data-id="element-291" data-mp="3r7g1u0yvxhfc" />

        <ol className="relative mt-12 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-292" data-mp="9rq2w28rc3bo">
          {roadmapSteps.map((step, i) => <li key={step.title} className="flex gap-4 rounded-3xl bg-brand-900 p-5 ring-1 ring-white/10 sm:p-6" data-id="element-293" data-mp="eqb3i2rx8p0n" data-mpi={i}>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cta text-xl font-extrabold text-cta-ink" data-id="element-294" data-mp="2uhp4zv34fi6d">
                {i + 1}
              </span>
              <div data-id="element-295" data-mp="26pqfz80i734l">
                <p className="text-xs font-extrabold uppercase tracking-wider text-mint-400" data-id="element-296" data-mp="26rb8ks39cbzt">Step {i + 1}</p>
                <h3 className="mt-1 text-lg font-extrabold text-white sm:text-xl" data-id="element-297" data-mp="21sgqjsd46rgr">{step.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-brand-100" data-id="element-298" data-mp="2gp7hrecmwwva">{step.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-299" data-mp="2pp49joubmbuk">
          <p className="text-2xl font-extrabold text-white sm:text-3xl" data-id="element-300" data-mp="2pnb5mhb3e5q9">
            One Organized Framework. <span className="text-cta" data-id="element-301" data-mp="2kprfaj14e2hy">Six Clear Planning Stages.</span>
          </p>
          <p className="mt-4 text-lg leading-relaxed text-brand-100" data-id="element-302" data-mp="2zdmbwai90r0b">
            The purpose is not to prescribe a universal treatment sequence. It is to give you a repeatable educational
            structure for planning individualized interventions using your clinical judgment and the available evidence.
          </p>
        </div>

        <SectionCTA dark label="Yes, I Want a Clearer Intervention Roadmap" data-id="element-303" data-mp="34c7cwc5brept" />
      </div>
    </section>;
}